export const SET_OPEN_EDITOR = "setOpenEditor";
